import { render, staticRenderFns } from "./Storyshop.vue?vue&type=template&id=4d91cf51&scoped=true&"
import script from "./Storyshop.vue?vue&type=script&lang=js&"
export * from "./Storyshop.vue?vue&type=script&lang=js&"
import style0 from "./Storyshop.vue?vue&type=style&index=0&id=4d91cf51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91cf51",
  null
  
)

export default component.exports